import {BaseFragment, BaseFragmentProps, BaseFragmentState} from "../../shared/BaseFragment";
import React, {ReactElement} from "react";
import {Button, Grid, Typography} from "@mui/material";
import {colorBlue} from "../../shared/colors";
import {AnswerState, Lesson, LessonContext, LessonType} from "./types";

export type BaseLessonFragmentProps = BaseFragmentProps & {
  lesson: Lesson,
  pageIndex: number,
  context: LessonContext,
}

export type BaseLessonFragmentState = BaseFragmentState & {}

const BUTTON_COLOR = "#ccc";
const BUTTON_COLOR_SELECTED = colorBlue;

export abstract class BaseLessonFragment<P extends BaseLessonFragmentProps, S extends BaseLessonFragmentState> extends BaseFragment<P, S> {

  static lessonType(): LessonType {
    return LessonType.FLIP;
  }

  static totalPages(): number {
    return 1;
  }

  protected renderQuestion(text: string): ReactElement {
    return <Typography variant="h4">{text}</Typography>
  }

  protected renderOption(index: number, text: string): ReactElement {
    const buttonColor = this.props.context.selectedOptionIndex() === index ? BUTTON_COLOR_SELECTED : BUTTON_COLOR;
    return <Grid item xs={6} md={3}>
      <Button
        disabled={this.props.context.answerState() !== AnswerState.NONE}
        onClick={() => this.props.context.setSelectedOptionIndex(index)}
        style={{border: "4px solid " + buttonColor, borderBottom: "8px solid " + buttonColor, width: "100%",}}>
        {this.renderOptionContent(text)}
      </Button>
    </Grid>
  }

  protected renderOptionContent(text: string): ReactElement {
    return <Typography variant="h2">{text}</Typography>;
  }
}

export abstract class BaseRecordAudioLessonFragment<P extends BaseLessonFragmentProps, S extends BaseLessonFragmentState> extends BaseLessonFragment<P, S> {

  static lessonType(): LessonType {
    return LessonType.RECORD_AUDIO;
  }

  abstract checkSelectedOption(): boolean;

  abstract correctAnswer(): string;

}